export interface InvalidateResponseInterface {
  status?: boolean
  message?: string | null
  errors?: { [key: string]: string[] }[]
}

export default (response?: InvalidateResponseInterface): boolean => {
  return !(response?.errors || response?.message || response?.status === false)
}
